class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.notification) {
      this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );
    }
  }

  open() {
    if (this.notification) {
      this.notification.classList.add('animate', 'active');
      this.notification.addEventListener(
        'transitionend',
        () => {
          this.notification.focus();
          trapFocus(this.notification);
        },
        { once: true }
      );
      document.body.addEventListener('click', this.onBodyClick);
    }
  }

  close() {
    if (this.notification) {
      this.notification.classList.remove('active');
      document.body.removeEventListener('click', this.onBodyClick);
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;

    // Atualiza o ícone do carrinho no header
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections?.['cart-icon-bubble']) {
      cartIconBubble.innerHTML = new DOMParser()
        .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section')?.innerHTML || '';
    }

    // Abre o drawer em vez da notificação
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Atualiza o conteúdo do drawer
      if (parsedState.sections?.['cart-drawer']) {
        const drawerItems = document.getElementById('CartDrawer-CartItems');
        if (drawerItems) {
          const parsed = new DOMParser().parseFromString(parsedState.sections['cart-drawer'], 'text/html');
          const newItems = parsed.querySelector('#CartDrawer-CartItems');
          if (newItems) drawerItems.innerHTML = newItems.innerHTML;
        }
      }
      cartDrawer.open();
      return;
    }

    // Fallback: notificação original
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-drawer',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
